import { getCarcLabelByCode } from '~/entities/carc-rarc'
import { cn } from '~/shared/lib/cn'

export function CarcBadge({
  carcList,
  rarcList,
  onClick,
}: {
  carcList: string[]
  rarcList: string[]
  onClick: () => void
}) {
  const firstCarc = carcList[0]
  const extraCount = carcList.length - 1 + rarcList.length

  return (
    <button
      type="button"
      className={cn(
        'bg-action-hovered text-primary-main shrink-0 cursor-pointer items-center gap-0.5 rounded-full border-none px-1 py-1 text-[14px] leading-[18px] whitespace-nowrap outline-none',
        'hover:bg-action-focused focus-visible:bg-primary-focused',
      )}
      onClick={onClick}
      title={getCarcLabelByCode(firstCarc) ?? firstCarc}
    >
      {firstCarc}
      {extraCount > 0 && <>&nbsp;(+{extraCount})</>}
    </button>
  )
}
